import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { ElementTypographyDto, SceneTypeDto } from "@repo/api/overlays";
import { FontSelect } from "./FontSelect";

type Props = {
  element: {
    externalId: string;
    typography: ElementTypographyDto;
  };
  sceneType: SceneTypeDto;
};

export default function ElementFontSection({ element }: Props) {
  const updateElement = useEditorStore((state) => state.service.updateElement);
  const rememberTextTypography = useEditorStore(
    (state) => state.service.rememberTextTypography,
  );

  const withTypography = (fn: (typography: ElementTypographyDto) => void) => {
    updateElement(element.externalId, (updatedElement) => {
      if (!("typography" in updatedElement)) {
        throw new Error("Typography is not in element");
      }

      fn(updatedElement.typography);
      rememberTextTypography(updatedElement.typography);
    });
  };

  return (
    <FontSelect
      fontFamily={element.typography.fontFamily}
      fontExternalId={element.typography.fontExternalId}
      fontWeight={element.typography.fontWeight}
      fontStyle={element.typography.fontStyle}
      fontSize={element.typography.fontSize}
      onSelectFont={({ font, fontWeight, fontStyle }) =>
        withTypography((typography) => {
          typography.fontFamily = font.family;
          typography.fontExternalId = font.externalId;
          typography.fontWeight = fontWeight;
          typography.fontStyle = fontStyle;
        })
      }
      onFontWeightChange={(fontWeight) =>
        withTypography((typography) => {
          typography.fontWeight = fontWeight;
        })
      }
      onFontStyleChange={(fontStyle) =>
        withTypography((typography) => {
          typography.fontStyle = fontStyle;
        })
      }
      onFontSizeChange={(fontSize) =>
        withTypography((typography) => {
          typography.fontSize = fontSize;
        })
      }
    />
  );
}
